<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  badge: { type: String, required: true },
  description: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  image: { type: String, required: true },
  imageAlt: { type: String, required: true },
  label: { type: String, required: true },
  selected: { type: Boolean, default: false },
  title: { type: String, required: true },
  value: { type: String, required: true },
});

const emit = defineEmits(['select']);
const { t } = useI18n();
</script>

<template>
  <button
    type="button"
    role="radio"
    :aria-checked="selected"
    :aria-label="title"
    :disabled="disabled"
    class="flex min-h-[330px] flex-col rounded-lais border bg-white p-5 text-left shadow-lais-card transition focus:outline-none focus:ring-2 focus:ring-lais-primary/30 disabled:cursor-not-allowed disabled:opacity-60"
    :class="
      selected
        ? 'border-lais-primary ring-2 ring-lais-primary/15'
        : 'border-lais-border-soft hover:border-lais-primary/50'
    "
    @click="emit('select', value)"
  >
    <span
      class="w-fit rounded-full px-2.5 py-1 text-[10px] font-bold tracking-[0.14em]"
      :class="
        selected
          ? 'bg-lais-primary text-white'
          : 'bg-lais-bg-soft text-lais-text-muted'
      "
    >
      {{ badge }}
    </span>
    <img
      :src="image"
      :alt="imageAlt"
      class="mx-auto my-5 h-28 w-full object-contain"
    />
    <span class="text-base font-semibold text-lais-text">{{ title }}</span>
    <span class="mt-2 text-sm leading-6 text-lais-text-body">
      {{ description }}
    </span>
    <span
      class="mt-auto flex items-center gap-2 pt-5 text-sm font-semibold text-lais-text"
    >
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full border"
        :class="
          selected
            ? 'border-lais-primary bg-lais-primary text-white'
            : 'border-lais-border-soft bg-white'
        "
      >
        <span
          v-if="selected"
          class="i-lucide-check text-xs"
          aria-hidden="true"
        />
      </span>
      {{ label || t('SALES.DELIVERY.START.OPTION.SELECT') }}
    </span>
  </button>
</template>
